import { React } from "react";
import { useState, useEffect, useRef } from "react";
import Wrapper from "../../components/UI/Wrapper";
import axios from "axios";
import "../../components/LeadPaymentDetails/LeadPaymentDetails.css";
import "react-toastify/dist/ReactToastify.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDown, faAngleUp } from "@fortawesome/free-solid-svg-icons";

const AccountsLeadRefundDetails = ({ Relocation_Id }) => {
  const baseAPI = process.env.REACT_APP_API_URL;
  const baseImageURL = process.env.REACT_APP_IMAGE_URL;
  const [refundReceiptResponse, setrefundReceiptResponse] = useState([]);
  const [loading, setLoading] = useState(false);
  const [openIndex, setOpenIndex] = useState(null);
  const [remarksList, setRemarksList] = useState([]);

  // Fetch rows data from the API
  useEffect(() => {
    getDocument(Relocation_Id);
  }, []);

  async function getDocument(Relocation_Id) {
    const storedToken = JSON.parse(localStorage.getItem("token"));
    if (storedToken) {
      axios
        .get(
          `${baseAPI}userget/GetRefundReceipts?relocation_id=` + Relocation_Id,
          {
            headers: {
              Authorization: `Bearer ${storedToken}`,
            },
          }
        )
        .then((response) => {
          setrefundReceiptResponse(response.data.data.RefundReceipts);
          setFirstItem(response.data.data.RefundReceipts[0]);
          setRemarksList(response.data.data.RefundRemarks);
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        });
    }
  }

  const [firstItem, setFirstItem] = useState({
    refundCancellationID: "",
    relocation_id: "",
    request_Type: "",
    revised_amount: "",
    refund_amount: "",
    is_status: "",
    old_estimate_docPath: "",
    old_estimate_docName: "",
    new_estimate_docPath: "",
    new_estimate_docName: "",
    remark: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFirstItem((prevItem) => ({
      ...prevItem,
      [name]: value,
    }));
  };

  async function updateRefund(refundCancellationID) {
    const payload = {
    refundCancellationID: refundCancellationID,
    relocation_id: Relocation_Id,
    request_Type: firstItem.request_Type,
    revised_amount: firstItem.revised_amount,
    refund_amount: firstItem.refund_amount,
    is_status: firstItem.is_status,
    remark: firstItem.remark,
  };

    try {
      const storedToken = JSON.parse(localStorage.getItem("token"));
      const response = await axios.post(
        `${baseAPI}userpost/UpdateRefundAccounts`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        }
      );
      getDocument(Relocation_Id);
    } catch (error) {
      console.error("Error posting data:", error);
    } finally {
      setLoading(false);
    }
  }

  const formatDate = (isoDate) => {
    if (!isoDate) return "";

    const date = new Date(isoDate);
    if (isNaN(date)) return "";

    const day = date.toLocaleString("en-GB", { day: "2-digit" });
    const month = date.toLocaleString("en-GB", { month: "short" });
    const year = date.getFullYear();
    const time = date.toLocaleString("en-GB", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });

    return `${day} ${month} ${year} | ${time}`;
  };

  return (
    <>
      <Wrapper className="LeadDetails">
        <div className="viewLeadDetails-form">
          <table
            style={{
              width: "100%",
              color: "#6A6A6A",
              borderRadius: "5px",
            }}
          >
            <tr className="viewLeadDetailsHeading">
              <th
                colSpan={4}
                style={{
                  background: "#5B489D",
                  color: "white",
                  fontWeight: "bold",
                }}
              >
                <span style={{ fontSize: "18px" }}> Request Details</span>
              </th>
            </tr>
          </table>
        </div>

        <div>
          {refundReceiptResponse !== null
            ? refundReceiptResponse.map((item, index) => (
                <>
                  <div className="viewLeadDetails-form"></div>

                  <div
                    style={{
                      border: "1px solid #DEE2E6",
                      borderRadius: "10px",
                      marginBottom: "-55px",
                    }}
                  >
                    <table className="paymentHistory">
                      <tr style={{ backgroundColor: "#F0EBFF" }}>
                        <th>Requested Time and Date</th>
                        <th>Request Type</th>
                        <th>Operations Coordinator</th>
                        <th>Revised Amount</th>
                        <th>Refund Amount</th>
                        <th>Status</th>
                        <th></th>
                      </tr>

                      <tr>
                        <td>{formatDate(item.created_date)}</td>
                        <td>
                          {item.request_Type === 1
                            ? "Partial Refund"
                            : "Full Refund"}
                        </td>
                        <td>{item.Assigned_By_Coordinator}</td>
                        <td>₹ {item.revised_amount}</td>
                        <td>₹ {item.refund_amount}</td>
                        <td
                          style={{
                            color: item.is_status === 0 ? "#FFA500" : "#20BF44",
                          }}
                        >
                          {item.is_status === 0 ? "Requested" : "Verified"}
                        </td>
                        <td style={{ textAlign: "center" }}>
                          <button
                            style={{
                              position: "relative",
                              top: "-33px",
                              maxWidth: "54px",
                              boxShadow: "0 1px 8px rgba(0, 0, 0, 0.25)",
                              border: "none",
                            }}
                            onClick={() =>
                              setOpenIndex(openIndex === index ? null : index)
                            }
                          >
                            {openIndex === index ? (
                              <FontAwesomeIcon icon={faAngleDown} />
                            ) : (
                              <FontAwesomeIcon icon={faAngleUp} />
                            )}
                          </button>
                        </td>
                      </tr>
                    </table>

                    {openIndex === index && (
                      <>
                        <hr />
                        <div className="viewLeadDetails-form">
                          <table
                            style={{
                              width: "100%",
                              color: "#6A6A6A",
                              borderRadius: "5px",
                            }}
                          >
                            <tr className="viewLeadDetailsHeading">
                              <th>
                                <span>Customer Name</span>
                              </th>
                              <td>
                                <span>{item.First_Name}</span>
                              </td>
                              <th>
                                <span>Number of Pets</span>
                              </th>
                              <td>
                                <span>{item.Number_Of_Pets}</span>
                              </td>
                            </tr>

                            <tr className="viewLeadDetailsHeading">
                              <th>
                                <span>Pet Name | Type</span>
                              </th>
                              <td>
                                <span>
                                  {item.pet_Name} | {item.PetType}
                                </span>
                              </td>
                              <th>
                                <span>Sales Coordinator Approval</span>
                              </th>
                              <td>
                                <span></span>
                              </td>
                            </tr>

                            <tr className="viewLeadDetailsHeading">
                              <th>
                                <span>Upload Old Estimate</span>
                              </th>
                              <td>
                                {item.old_estimate_docName && (
                                  <span>
                                    <a
                                      style={{
                                        color: "#0096EB",
                                        textDecoration: "none",
                                        cursor: "pointer",
                                        fontWeight: "bold",
                                      }}
                                      target="_blank"
                                      href={`${baseImageURL}Images/Documents/${item.relocation_id}/${item.old_estimate_docName}`}
                                      rel="noopener noreferrer"
                                    >
                                      Estimate
                                    </a>
                                  </span>
                                )}
                              </td>
                              <th>
                                <span>Upload New Estimate</span>
                              </th>
                              <td>
                                {item.new_estimate_docName && (
                                  <span>
                                    <a
                                      style={{
                                        color: "#0096EB",
                                        textDecoration: "none",
                                        cursor: "pointer",
                                        fontWeight: "bold",
                                      }}
                                      target="_blank"
                                      href={`${baseImageURL}Images/Documents/${item.relocation_id}/${item.new_estimate_docName}`}
                                      rel="noopener noreferrer"
                                    >
                                      Estimate
                                    </a>
                                  </span>
                                )}
                              </td>
                            </tr>
                            <tr className="viewLeadDetailsHeading">
                              <th>
                                <span>Revised Amount</span>
                              </th>
                              <td>
                                <input
                                  className="form-control"
                                  type="number"
                                  name="revised_amount"
                                  value={firstItem.revised_amount}
                                  onChange={handleChange}
                                />
                              </td>
                              <th>
                                <span>Refund Amount</span>
                              </th>
                              <td>
                                <input
                                  className="form-control"
                                  type="number"
                                  name="refund_amount"
                                  value={firstItem.refund_amount}
                                  onChange={handleChange}
                                />
                              </td>
                            </tr>
                            <tr className="viewLeadDetailsHeading">
                              <th>
                                <span>Sales Manager's Approval</span>
                              </th>
                              <td>
                                <span></span>
                              </td>
                              <th>
                                <span>Finance Approval</span>
                              </th>
                              <td>
                                <select
                                  className="form-control"
                                  name="is_status"
                                  value={firstItem.is_status}
                                  onChange={handleChange}
                                >
                                  <option selected value="">
                                    Select Approval
                                  </option>
                                  <option value="0">Requested</option>
                                  <option value="1">Approved</option>
                                </select>
                              </td>
                            </tr>
                            <tr className="viewLeadDetailsHeading">
                              <th>
                                <span>Remark (if any)</span>
                              </th>
                              <td colSpan={3}>
                                <div
                                  className="row"
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    height: "70px",
                                  }}
                                >
                                  <div className="col-10">
                                    <input
                                      // className="form-control"
                                      type="text"
                                      name="remark"
                                      value={firstItem.remark}
                                      onChange={handleChange}
                                      style={{ width: "100%", height: "32px" }}
                                    />
                                  </div>
                                  <div className="col-2">
                                    <button
                                      style={{
                                        backgroundColor: "#5B489D",
                                        color: "white",
                                        width: "93%",
                                        // margin: "7px",
                                      }}
                                      className="btn btn-success inputDoc3"
                                      onClick={() =>
                                        updateRefund(item.refundCancellationID)
                                      }
                                    >
                                      Submit 
                                    </button>
                                  </div>
                                </div>
                              </td>
                            </tr>
                          </table>
                        </div>

                        <h3
                          style={{
                            marginTop: "1rem",
                            fontSize: "16px",
                            fontWeight: "bold",
                          }}
                        >
                          {" "}
                          Remarks Timeline
                        </h3>
                        <div
                          style={{
                            width: "100%",
                            maxHeight: "300px",
                            overflowY: "scroll",
                            alignItems: "center",
                          }}
                        >
                          <table
                            className="customerDetailsTable"
                            style={{ width: "99%", marginLeft: "5px" }}
                          >
                            {remarksList
                              .filter(
                                (remark) =>
                                  remark.refundCancellationID ===
                                  item.refundCancellationID
                              )
                              .map((remark, index) => (
                                <div
                                  className="wrapper"
                                  style={{
                                    width: "100%",
                                    display: "flex",
                                    flexDirection: "column",
                                    margin: "1rem",
                                    padding: "1rem",
                                    borderBottom: "1px solid #ddd",
                                  }}
                                  key={index}
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      flexDirection: "row",
                                      justifyContent: "space-between",
                                    }}
                                  >
                                    <h3 className="card-title">
                                      <b>Remark</b>
                                    </h3>
                                    <p className="card-text">
                                      <b>{formatDate(remark.created_date)}</b>
                                    </p>
                                  </div>
                                  <div
                                    className="row"
                                    style={{
                                      paddingTop: "11px",
                                      border: "none",
                                    }}
                                  >
                                    <div className="col-12">
                                      <div
                                        className="card"
                                        style={{
                                          width: "100%",
                                          background: "none",
                                        }}
                                      >
                                        <div className="card-body">
                                          <p
                                            className="card-text"
                                            style={{
                                              fontSize: "14px",
                                              fontWeight: "bold",
                                            }}
                                          >
                                            {remark.Name} - {remark.remark}
                                          </p>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              ))}
                          </table>
                        </div>
                      </>
                    )}

                    <br />
                  </div>
                  <br />
                  <br />
                </>
              ))
            : null}
        </div>
      </Wrapper>
      <br />
    </>
  );
};

export default AccountsLeadRefundDetails;
